var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column align-center pt-10 pb-15 billing-tab-container"},[_c('BillingExceptions'),_c('BillingMultipliers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }